import React from 'react'
import "./laptop.css"
import Floater from '../Floaters/Floater'

function Laptop() {
  return (
    <div>
    <Floater />
    <div className="laptop-wrapper">
  <div className="hover">
    <div className="image-container">
      <img className="device" src="https://iili.io/HLEhQaV.png" alt="Laptop" />
      <iframe className='screen'
src="https://www.youtube.com/embed/BhgGUWWtYsk">
</iframe>
    </div>
  </div>
</div>
    </div>
  )
}

export default Laptop